(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["clothing-variant-picker"] && !Shopify.designMode) return;
  try {
    class ClothingVariantPicker extends HTMLElement {
    constructor() {
      super();
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.form = this.closest('product-form-component');
      this.formInput = this.form.querySelector('input[name="id"]');

      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
      const selectedVariantId = event.target.dataset.variantId;
      const selectedVariant = this.variants.find(variant => variant.id == selectedVariantId);

      if (selectedVariant) {
        this.updateURL(selectedVariant.id);
        this.updateFormId(selectedVariant.id);
        this.updateActiveVariant(event.target);
      }
    }

    updateURL(variantId) {
      if (!variantId) return;
      window.history.replaceState({}, '', `${this.dataset.productUrl}?variant=${variantId}`);
    }

    updateFormId(variantId) {
      this.formInput.value = variantId;
    }

    updateActiveVariant(target) {
      this.querySelectorAll('label').forEach(label => {
        label.classList.remove('bg-california-cabernet', 'text-snow-white', 'border-california-cabernet');
        label.classList.add('bg-snow-white', 'text-toasted-barrel', 'border-toasted-barrel');
      });

      const targetLabel = target.closest('label');
      targetLabel.classList.add('bg-california-cabernet', 'text-snow-white', 'border-california-cabernet');
      targetLabel.classList.remove('bg-snow-white', 'text-toasted-barrel', 'border-toasted-barrel');
    }
  }

  customElements.define('clothing-variant-picker', ClothingVariantPicker);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cta-video"] && !Shopify.designMode) return;
  try {
    class CtaVideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.isPlaying = this.getAttribute('video-autoplay') === 'true';
    this.videoType = this.getAttribute('video-type');
    this.sectionId = this.getAttribute('section-id');
    this.showControls = this.hasAttribute('show-controls');
  }

  connectedCallback() {
    if (!this.showControls) return;
    
    this.setupVideoControls();
  }

  setupVideoControls() {
    const toggleButton = this.querySelector(`[data-video-toggle="${this.sectionId}"]`);
    if (!toggleButton) return;

    this.toggleButton = toggleButton;
    this.playIcon = toggleButton.querySelector('.play-icon');
    this.pauseIcon = toggleButton.querySelector('.pause-icon');
    
    // Find video element based on type
    this.externalVideo = this.querySelector('[data-external-video]');
    this.shopifyVideo = this.querySelector('[data-shopify-video]');
    this.videoEl = this.externalVideo || this.shopifyVideo || this.querySelector('video');

    // Set up event listeners
    this.toggleButton.addEventListener('click', this.handleToggle.bind(this));

    if (this.videoEl) {
      this.setupHtml5VideoEvents();
    }

    // Set initial icon state
    this.updateIconState();
  }

  handleToggle() {
    if (!this.videoEl) return;
    this.handleHtml5Toggle();
  }

  handleHtml5Toggle() {
    if (this.videoEl.paused) {
      this.videoEl.play();
      this.isPlaying = true;
    } else {
      this.videoEl.pause();
      this.isPlaying = false;
    }
    this.updateIconState();
  }

  setupHtml5VideoEvents() {
    this.videoEl.addEventListener('play', () => {
      this.isPlaying = true;
      this.updateIconState();
    });

    this.videoEl.addEventListener('pause', () => {
      this.isPlaying = false;
      this.updateIconState();
    });
  }

  updateIconState() {
    if (!this.playIcon || !this.pauseIcon) return;
    
    if (this.isPlaying) {
      this.playIcon.classList.add('hidden');
      this.pauseIcon.classList.remove('hidden');
    } else {
      this.playIcon.classList.remove('hidden');
      this.pauseIcon.classList.add('hidden');
    }
  }
}

customElements.define('cta-video-player', CtaVideoPlayer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["label-input"] && !Shopify.designMode) return;
  try {
    // Label Input Web Component
  class LabelInput extends HTMLElement {
    constructor() {
      super();
      this.setupEventListeners();
    }

    static get observedAttributes() {
      return [
        'id', 'name', 'type', 'placeholder', 'value', 'label', 'hint', 
        'error', 'left-icon', 'right-icon', 'disabled', 'required', 'variant'
      ];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue !== newValue) {
        this.updateComponent();
      }
    }

    setupEventListeners() {
      const input = this.querySelector('.input');
      const leftIcon = this.querySelector('.icon.left');
      const rightIcon = this.querySelector('.icon.right');

      if (input) {
        const updateClearButtonVisibility = () => {
          if (this.getAttribute('variant') === 'search') {
            const clearButton = this.querySelector('.icon.right[data-role="clear"]');
            if (!clearButton) return;
            if (input.value.length > 0) {
              clearButton.classList.remove('hidden');
            } else {
              clearButton.classList.add('hidden');
            }
          }
        };
        // Handle input focus
        input.addEventListener('focus', () => {
          this.classList.add('focused');
          // Show/hide clear icon depending on value on focus
          updateClearButtonVisibility();
        });

        // Handle input blur
        input.addEventListener('blur', () => {
          this.classList.remove('focused');
          // Ensure hidden when empty and not focused
          updateClearButtonVisibility();
        });

        // Handle input changes
        input.addEventListener('input', () => {
          if (input.value.length > 0) {
            this.classList.add('has-value');
          } else {
            this.classList.remove('has-value');
          }

          // Dispatch custom event
          this.dispatchEvent(new CustomEvent('input-change', {
            detail: { value: input.value },
            bubbles: true
          }));
          // Toggle clear icon visibility for search variant
          updateClearButtonVisibility();
        });

        // Initialize has-value class if input has a value
        if (input.value.length > 0) {
          this.classList.add('has-value');
        }
        // Initial clear button visibility
        updateClearButtonVisibility();
      }

      // Handle left icon click (for search submit functionality)
      if (leftIcon) {
        leftIcon.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Check if this is a search icon
          const isSearchIcon = leftIcon.getAttribute('aria-label') === 'Submit search';
          
          if (isSearchIcon) {
            // Submit search functionality
            this.dispatchEvent(new CustomEvent('submit', {
              detail: { value: input ? input.value : '', element: input },
              bubbles: true
            }));
          }

          // Dispatch custom event
          this.dispatchEvent(new CustomEvent('icon-click', {
            detail: { 
              icon: 'left', 
              type: this.getAttribute('left-icon'),
              action: isSearchIcon ? 'submit' : 'click'
            },
            bubbles: true
          }));
        });
      }

      // Handle right button click (for clear or submit functionality)
      if (rightIcon) {
        rightIcon.addEventListener('click', (e) => {
          e.preventDefault();
          
          // Check if this is a clear button or submit button
          const isCloseButton = rightIcon.getAttribute('data-role') === 'clear';
          
          if (isCloseButton) {
            // Clear the input
            if (input) {
              input.value = '';
              input.focus();
              this.classList.remove('has-value');
              
              // Trigger input event
              input.dispatchEvent(new Event('input', { bubbles: true }));
            }
          } else {
            // Submit functionality
            this.dispatchEvent(new CustomEvent('submit', {
              detail: { value: input ? input.value : '', element: input },
              bubbles: true
            }));
          }

          // Dispatch custom event
          this.dispatchEvent(new CustomEvent('icon-click', {
            detail: { 
              icon: 'right', 
              type: isCloseButton ? 'so-close.svg' : 'so-arrow-right.svg',
              action: isCloseButton ? 'clear' : 'submit'
            },
            bubbles: true
          }));
        });
      }
    }

    updateComponent() {
      // Re-setup event listeners after attribute changes
      this.setupEventListeners();
    }

    // Public methods
    getValue() {
      const input = this.querySelector('.input');
      return input ? input.value : '';
    }

    setValue(value) {
      const input = this.querySelector('.input');
      if (input) {
        input.value = value;
        this.setAttribute('value', value);
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    setError(error) {
      if (error) {
        this.setAttribute('error', error);
        this.classList.add('error');
      } else {
        this.removeAttribute('error');
        this.classList.remove('error');
      }
    }

    clearError() {
      this.removeAttribute('error');
      this.classList.remove('error');
    }

    disable() {
      this.setAttribute('disabled', '');
      this.classList.add('disabled');
    }

    enable() {
      this.removeAttribute('disabled');
      this.classList.remove('disabled');
    }
  }

  // Register the web component
  customElements.define('label-input', LabelInput);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["style-guide-buttons"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.btn.hover').forEach(button => {
    button.addEventListener('mouseleave', () => {
      button.classList.add('hover');
    });
  });

  document.querySelectorAll('.btn.active').forEach(button => {
    button.addEventListener('mouseup', () => {
      button.classList.add('active');
    });
  });

  document.querySelectorAll('.text-link-button--hover').forEach(link => {
    link.addEventListener('mouseenter', () => {
      link.classList.add('hover');
    });
    link.addEventListener('mouseleave', () => {
      link.classList.remove('hover');
    });
  });

  document.querySelectorAll('.text-link-button--active').forEach(link => {
    link.addEventListener('mousedown', () => {
      link.classList.add('active');
    });
    link.addEventListener('mouseup', () => {
      link.classList.remove('active');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["style-guide-inputs"] && !Shopify.designMode) return;
  try {
    // Demo functionality
document.addEventListener('DOMContentLoaded', () => {
  // Search submit button demo
  const searchInput = document.querySelector('#demo-search');
  const searchResult = document.querySelector('#search-demo-result');
  
  if (searchInput && searchResult) {
    searchInput.addEventListener('submit', (e) => {
      searchResult.textContent = `Search submit triggered with value: "${e.detail.value}"`;
      searchResult.style.color = 'green';
    });
  }
  
  // Submit button demo
  const submitInput = document.querySelector('#demo-arrow');
  const submitResult = document.querySelector('#submit-demo-result');
  
  if (submitInput && submitResult) {
    submitInput.addEventListener('submit', (e) => {
      submitResult.textContent = `Submit triggered with value: "${e.detail.value}"`;
      submitResult.style.color = 'green';
    });
  }
  
  // Clear button demo
  const clearInput = document.querySelector('#demo-clear');
  const clearResult = document.querySelector('#clear-demo-result');
  
  if (clearInput && clearResult) {
    clearInput.addEventListener('icon-click', (e) => {
      if (e.detail.action === 'clear') {
        clearResult.textContent = `Input cleared! Previous value was: "${e.detail.value}"`;
        clearResult.style.color = 'blue';
      }
    });
  }
  
  // General icon click demo
  document.querySelectorAll('label-input').forEach(input => {
    input.addEventListener('icon-click', (e) => {
      console.log('Icon clicked:', e.detail);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
